export default function LicenseReasons() {
  return [
    { label: "I use public or commercial transportation", value: "I use public or commercial transportation" },
    { label: "Parking violations or child support", value: "Parking violations or child support" },
    { label: "My license has been suspended or revoked", value: "My license has been suspended or revoked" },
    { label: "I have a medical restriction to driving", value: "I have a medical restriction to driving" },
    { label: "I am unable to physically appear at the license bureau", value: "I am unable to physically appear at the license bureau" },
    { label: "I have never had a driver's license due to personal choice", value: "I have never had a driver's license due to personal choice" },
  ];
}
